import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as BackIcon } from '../../../../assets/icons/arrow-back.svg';
import styles from './BackHeader.module.scss';
import Header, { HeaderProps } from '../Header/Header';

interface BackProps {
  action?: () => void
}
export function Back({ action }: BackProps) {
  const navigate = useNavigate();

  const onClick = () => {
    if (action) {
      action();
      return;
    }
    navigate(-1);
  }

  return (
    <div className={styles.backContainer} onClick={onClick}>
      <BackIcon className={styles.icon} />
    </div>
  )
}

interface BackHeaderProps extends HeaderProps, BackProps {
  backHidden?: boolean
}
function BackHeader(props: BackHeaderProps) {
  const { children, action, backHidden, ...otherProps } = props;

  const left = useMemo(() => {
    if (backHidden) return null;
    return <Back action={action} />
  }, [ backHidden ])

  return (
    <Header left={left} {...otherProps}>
      { children }
    </Header>
  )
}

export default BackHeader;
